import { redirect, NOT_FOUND } from 'redux-first-router'
import {CONTENT_ROUTE, toggleMenu, toggleSearchDialog, closeMobileMenu} from "./actions"
import {globalContentLoaded, pageContentLoaded, pageContentDiscarded} from "./actions"
import {fetchGlobalContent, getArticleContent, getSearchContent, getTodayContent} from "./api"
import { beginTask, endTask } from 'redux-nprogress';
import querySerializer from 'query-string'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import {getMenuIsOpen, getSearchDialogIsOpen, getCurrentLocation} from "./selectors"
import {FETCH_SEARCH_RESULTS_SUCCESSFUL, searchQueryChanged} from "./actions/search";
import {getSelectedGender} from "./selectors"
import get from 'lodash/get'
import {BASE_URL} from './config'
import {isHomePath} from './utils/pages'

function isRedirect(location, pageContent) {
    return false;
}

export default {
    CONTENT_ROUTE: {
        path: '*',
        thunk: async (dispatch, getState) => {

            // Close the menu if it is open
            if(getMenuIsOpen(getState())) dispatch(toggleMenu());
            dispatch(beginTask());
            const { location, content } = getState()
            const gender = getSelectedGender(getState());

            // redirect to the gender version of the page if it is selected
            if(gender && gender !== 'all' && gender !== 'everything' && gender !== get(location, ['query', 'g']))
            {
                dispatch(endTask());
                return dispatch(redirect({ type: CONTENT_ROUTE, payload: [location.pathname], query: { g: gender } }));
            }

            try
            {
                let globalContent = content.global;
                if( ! globalContent ) {
                    const { experiments } = getState()
                    globalContent = await fetchGlobalContent({ref: experiments.ref});
                    dispatch(globalContentLoaded(globalContent))
                }

                let pageContent;

                if(location.pathname === `${BASE_URL}/search`) {
                    pageContent = await getSearchContent(dispatch, getState);
                    if( location.query && location.query.q ) {
                        await dispatch( searchQueryChanged({...pageContent, gender: []}, false) );
                        await dispatch( {type: FETCH_SEARCH_RESULTS_SUCCESSFUL, payload: pageContent } );
                    }
                }
                else if ( isHomePath( location.pathname ) ) {
                    pageContent = await getTodayContent(getState);
                }
                else {
                    pageContent = await getArticleContent(dispatch, getState, globalContent);
                }

                //We have moved location since the call was made to fetch the content, so just throw the data away
                if( location !== getCurrentLocation(getState()) ) {
                    dispatch( pageContentDiscarded(pageContent) )
                    return;
                }

                if(!pageContent || !pageContent.type) {
                    dispatch(endTask());
                    return dispatch({type: NOT_FOUND})
                }

                if(isRedirect(location, pageContent)) {
                    dispatch(endTask());
                    return dispatch(redirect({ type: CONTENT_ROUTE }));
                }
                clearAllBodyScrollLocks()
                dispatch(closeMobileMenu())
                dispatch( pageContentLoaded(pageContent) )

            } catch (ex) {
                console.error(ex)
                return dispatch({type: NOT_FOUND})
            }
            finally {
                if(getSearchDialogIsOpen(getState())) dispatch(toggleSearchDialog());
                dispatch(endTask());
            }
        }
    },

}

export const options = {
    querySerializer,
    onBeforeChange: (dispatch, getState, action) => {
    },
    onAfterChange: (dispatch, getState) => {
    }
}



// WEBPACK FOOTER //
// ./src/routesMap.js